module.exports = __webpack_public_path__ + "img/max_isack_register.b8a9bb38.png";